import { z } from 'zod';

export enum OptionValue {
  YES = 'yes',
  NO = 'no',
}

const capitalDepositEUBankAccountSchema = z.object({
  hasEuropeanBankAccount: z.nativeEnum(OptionValue),
});

export type CapitalDepositEUBankAccountSchema = z.infer<
  typeof capitalDepositEUBankAccountSchema
>;

export default capitalDepositEUBankAccountSchema;
